import {createSlice} from '@reduxjs/toolkit';



export const SessionSlice = createSlice({
   name : 'session',
    initialState:{
        user:{},
        trading:{ started:false,tradingActive:false,},
        bot:{ amount: 0.1, marketCap: 28, maxOpenTrades:6,slippage:5,priorityfee:0.0005, sellMc: 50, maxEntries: 5, address: "", secret: "ddddddddd", stopLoss: 2 ,buyMc:"",ownerTokenHoldings:10,twitter:false,telegram:false,website:true,},
        address:'',
        token:"",
        tradingData:{},
        tradingSessionData:[],
        socket:false,
    
    },
    reducers:{
        setBotSettings:(state,action)=>{
            state.bot = {...state.bot,...action.payload}
        },
        setUserData:(state,action)=>{
            state.user = {...state.user,...action.payload}
        },
        login:(state,action)=>{
        state.address=action.payload
        state.bot.address = action.payload
        },
        setTradingData : (state,action)=>{
            state.tradingData = {...state.tradingData ,...action.payload}
        },
        setTradingData:(state,action)=> {
            state.tradingData ={...state.tradingData,...action.payload}
        },
        setToken:(state,action)=> {
            state.token =action.payload
        },
        setTradingSessionData:(state,action)=> {
            state.tradingSessionData =action.payload
        },

    }
})



export const {
    setBotSettings,
    setSocket,
    setToken,
    setUserData,
    setTradingData,
    login,
    setTradingSessionData,
    

} = SessionSlice.actions


// export let socket = null


// export const  connectBot = async (address) => {
//     // Open WebSocket connection if it's not already open
//     if (!socket || socket.readyState === WebSocket.CLOSED) {
//       socket = new WebSocket(`ws://localhost:3000?address=${address}`);
//      toast.info('Awaiting connection ...',{duration:500})
//      socket.onopen = () => {
//           console.log('socket connected from the slice')

//       };
//             socket.onerror = (err) => {
//               console.error('WebSocket error:', err);
//               toast.error('Could not connect to server')
//               socket = null
//             };
            
//             socket.onclose = () => {
//                 console.log({ isConnected: false })
//                 toast.warning('Connection to server Closed or corrupted')
//               socket = null
      
//             };
//           } else {
//             toast.info('connection with Server is already established.');
//           }
//   };
    


